<template>
  <div class="pwc-event-home">
    <navigation />
    <pwc-container v-if="$route.query.active==='event'" :max="1200">
      <event-list :list="eventList" @go:event:detail="handleGoEventDetail" @register="handleRegister" />
    </pwc-container>

    <pwc-container v-else-if="$route.query.active==='document'" :max="1200">
      <product-list />
    </pwc-container>

    <pwc-container v-else>
      <self-center />
    </pwc-container>
  </div>
</template>

<script>
import Navigation from '../../layout/desktop/PwcNav'
import PwcContainer from '../../layout/desktop/PwcContainer'
import EventList from '../../../components/EventList/desktop'
import SelfCenter from '../../../components/SelfCenter/desktop'
import ProductList from '../../../components/ProductList/desktop'
import { logic } from '../common/mixin/logic'
import { ProgrammeType } from '@/constants/type'

export default {
  provide() {
    return {
      home: this
    }
  },
  components: {
    Navigation,
    PwcContainer,
    EventList,
    SelfCenter,
    ProductList
  },
  mixins: [logic],
  computed: {
    cInfoList() {
      let ageObj = {}
      let gradeObj = {}
      let workYearObj = {}
      if (this.lookups.ageRange) {
        ageObj = this.lookups.ageRange.find(v => v.id === this.userInfo.age) || {}
        gradeObj = this.lookups.anchorStudentGrades.find(v => v.id === this.userInfo.grade) || {}
        workYearObj = this.lookups.workYearRange.find(v => v.id === this.userInfo.yearsOfWork) || {}
      }
      const infos = [
        this.createInfo('姓名', this.userInfo.name, 'fas fa-ellipsis-v'),
        this.createInfo('年龄', ageObj.name || this.userInfo.age, 'fas fa-ellipsis-v'),
        this.createInfo('邮箱', this.userInfo.email, 'fas fa-ellipsis-v')
      ]
      if (this.userInfo.programmeType === ProgrammeType.Anchor) {
        const schools = [
          this.createInfo('学校', this.userInfo.eduInstitution, 'fas fa-ellipsis-v'),
          this.createInfo('专业', gradeObj.name || this.userInfo.grade, 'fas fa-ellipsis-v'),
          this.createInfo('年级', this.userInfo.major, 'fas fa-ellipsis-v')
        ]
        infos.push(...schools)
      }
      if (this.userInfo.programmeType === ProgrammeType.YouPlus) {
        const works = [
          this.createInfo('公司', this.userInfo.company, 'fas fa-ellipsis-v'),
          this.createInfo('职称', this.userInfo.title, 'fas fa-ellipsis-v'),
          this.createInfo('工作年限', workYearObj.name || this.userInfo.yearsOfWork, 'fas fa-ellipsis-v')
        ]
        infos.push(...works)
      }
      return infos
    },
    cLoading() {
      return this.loading.eventListLoading ||
       this.loading.registerEventLoading ||
       this.loading.approvedEventLoading ||
       this.loading.registeredEventsLoading
    }
  },
  created() {
    this.getApprovedEvents()
    this.getRegisteredEvents()
    this.fetchLookups()
  },
  methods: {
    createInfo(name, value, icon) {
      return {
        name: name,
        value: value,
        icon: icon
      }
    }
  }
}
</script>

